import { render, staticRenderFns } from "./EmployeesEnquirySalariesPaidAdd.vue?vue&type=template&id=4e3577cd&scoped=true&"
import script from "./EmployeesEnquirySalariesPaidAdd.vue?vue&type=script&lang=js&"
export * from "./EmployeesEnquirySalariesPaidAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3577cd",
  null
  
)

export default component.exports